import { Component, ViewChild, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ModalComponent } from '../../../components/modal/modal.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from '../../../components/toast/toast.service';
import { UploadingFile } from '../uploader.component';
import { SearchService } from '../../../services/search.service';
import Utils from '../../../services/utils';
import { UploaderService } from '../../../services/uploader.service';

@Component({
  selector: 'lowy-grading-meta',
  template: `
  <lowy-modal #modal>
    <div class="form">
      <div class="headline">Grading Metadata</div>
      <div class="subheading">Please hit the save button to move the file into your complete queue.
      </div>
      <div class="seperator"></div>
      <div class="icon-label-row">
        <div class="data-icon-clear family"><i class="material-icons">people</i></div>
        <div class="headline">{{file?.fileName}}</div>
      </div>
      <mat-spinner *ngIf="loading"></mat-spinner>
      <div class="seperator"></div>
      <div class="button-row">
        <span (click)="cancel()">cancel</span>
        <span (click)="!loading && save()" [ngClass]="{disabled: loading}">{{saveText}}</span>
      </div>
    </div>
  </lowy-modal>
  `,
})
export class GradingMetaComponent implements OnInit {
  public file: UploadingFile;
  public loading: boolean;

  @ViewChild('modal') modal: ModalComponent;

  @Output() onSave: EventEmitter<any>;
  @Input('saveText') saveText: string;

  constructor(private formBuilder: FormBuilder, private toastService: ToastService, private uploaderService: UploaderService) {
    this.onSave = new EventEmitter();
  }

  async ngOnInit() {
  }

  public async open(file: UploadingFile) {
    this.file = file;
    // wait for self to be closed and hidden, because parent caller will sometimes try to open me up too fast
    while (this.modal.visible) {
      await Utils.sleep(150);
    }
    this.modal.open();
  }

  async save() {
    try {
      this.loading = true;
      await this.uploaderService.processGradingSpreadsheet(this.file);
      this.onSave.emit(this.file);
      this.loading = false;
      this.modal.close();
    }
    catch (err) {
      this.loading = false;
      this.modal.close();
      this.toastService.throwToast('Error saving grading data');
    }
  }

  cancel() {
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/uploader/modals/grading-meta-modal.component.ts